var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7226 5.294C23.095 5.66829 23.3631 6.13426 23.5002 6.64534C23.9941 8.52608 24 12.4524 24 12.4524C24 12.4524 24 16.3787 23.5002 18.2594C23.3631 18.7705 23.095 19.2365 22.7226 19.6108C22.3503 19.9851 21.8867 20.2546 21.3783 20.3924C19.5074 20.8968 12 20.8968 12 20.8968C12 20.8968 4.49457 20.8968 2.62364 20.3924C2.11505 20.2549 1.65131 19.9855 1.27892 19.6112C0.906516 19.2368 0.638529 18.7707 0.50181 18.2594C0 16.3787 0 12.4524 0 12.4524C0 12.4524 0 8.52608 0.50181 6.64534C0.637318 6.13261 0.904766 5.6648 1.27725 5.28898C1.64972 4.91315 2.1141 4.64257 2.62364 4.50444C4.49259 4 12 4 12 4C12 4 19.5054 4 21.3783 4.51239C21.8867 4.65019 22.3503 4.9197 22.7226 5.294ZM15.836 12.4518L9.59896 16.0703V8.83333L15.836 12.4518Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1f68376f0cdc6af95f03cec948adec1d.svg";
export { ForwardRef as ReactComponent };